var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content/General English"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0003 2.16699C5.40033 2.16699 1.66699 5.90033 1.66699 10.5003C1.66699 15.1003 5.40033 18.8337 10.0003 18.8337C14.6003 18.8337 18.3337 15.1003 18.3337 10.5003C18.3337 5.90033 14.6003 2.16699 10.0003 2.16699ZM3.33366 10.5003C3.33366 9.99199 3.40033 9.49199 3.50866 9.01699L7.49199 13.0003V13.8337C7.49199 14.7503 8.24199 15.5003 9.15866 15.5003V17.1087C5.88366 16.692 3.33366 13.892 3.33366 10.5003ZM14.9087 15.0003C14.692 14.3253 14.0753 13.8337 13.3253 13.8337H12.492V11.3337C12.492 10.8753 12.117 10.5003 11.6587 10.5003H6.65866V8.83366H8.32533C8.78366 8.83366 9.15866 8.45866 9.15866 8.00033V6.33366H10.8253C11.742 6.33366 12.492 5.58366 12.492 4.66699V4.32533C14.9337 5.30866 16.667 7.70866 16.667 10.5003C16.667 12.2337 15.992 13.817 14.9087 15.0003Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralEnglish);
export default __webpack_public_path__ + "static/media/general-english.4c4b2e47e6a786b5902803d365f7b7bd.svg";
export { ForwardRef as ReactComponent };